import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { KPIDefinitionDto } from '@ts/ui-models';

export interface KPI {
  kpiSelected: KPIDefinitionDto | null;
  kpiList: KPIDefinitionDto[];
}
type KPIKey = keyof KPI;

const initialState: KPI = {
  kpiSelected: null,
  kpiList: [],
};

//const KPIEntity = createEntityAdapter<KPI>();

export const KPISlice = createSlice({
  name: 'KPI',
  initialState,
  reducers: {
    updateKPIState(state, action: PayloadAction<{ key: KPIKey; value: any }>) {
      const { key, value } = action.payload;
      if (key) {
        state[key] = value;
      }
    },
  },
});

export const KPIActions = KPISlice.actions;

export const KPISelectors = (state: KPI) => state;
